import { useContext } from 'react';
import QuickHelpContext from './context';
import type { QuickHelpContextValue } from './types';

export default function useQuickHelpContext(): QuickHelpContextValue {
    const ctx = useContext(QuickHelpContext);
    if (!ctx) {
        throw new Error('useQuickHelpContext must be used inside QuickHelpProvider');
    }
    return ctx;
}
